import { render } from "./manage-tags.vue?vue&type=template&id=2653fd16&ts=true"
import script from "./manage-tags.vue?vue&type=script&lang=ts"
export * from "./manage-tags.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__